/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_5Inputs */

const es_chat_suggestions_welcome_5 = /** @type {(inputs: Chat_Suggestions_Welcome_5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Sobre qué tema te gustaría trabajar hoy, ${i?.name}?`)
};

const en_chat_suggestions_welcome_5 = /** @type {(inputs: Chat_Suggestions_Welcome_5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What would you like to focus on today, ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "What would you like to focus on today, {name}?" |
*
* @param {Chat_Suggestions_Welcome_5Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_5 = /** @type {((inputs: Chat_Suggestions_Welcome_5Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_5Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_5(inputs)
	return en_chat_suggestions_welcome_5(inputs)
});
export { chat_suggestions_welcome_5 as "chat.suggestions.welcome_5" }